import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, IconButton, Tooltip, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";


export const GallerySection = ({ endpointsUrl, instituteRes }) => {

    const isMobile = useMediaQuery("(min-width:600px)");
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [selectedImage, setSelectedImage] = useState("");
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    useEffect(() => {
        if (instituteRes?.gallery) {
            setSelectedImage(instituteRes?.gallery?.[0] || '')
        }
    }, [instituteRes])

    // console.log('selectedImage', selectedImage, "instituteRes", instituteRes);

    return (
        <div style={{ paddingLeft: isMobile ? '6rem' : '1.3rem', paddingRight: isMobile ? '6rem' : '1rem', }}>
            <Grid container spacing={2}>

                <Grid item xs={12} sm={12} md={12} lg={12}
                    sx={{
                        borderRadius: '10px',
                        background: '#fff',
                        py: [2, 2]
                    }}
                >
                    {instituteRes?.gallery?.length > 0 && (
                        <Grid container>
                            <Grid item xs={12}>
                                <Typography
                                    sx={{
                                        mb: 3,
                                        mt: 5,
                                        color: "black",
                                        width: "100%",
                                        textAlign: 'center'
                                    }}
                                    fontSize="16px"
                                    fontWeight="bold"
                                >
                                    Vsmart Examprep Known for our Qualitative Learning.
                                </Typography>

                                {/* Main Image Display */}
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        overflow: "hidden",
                                        borderRadius: "10px",
                                        mb: 4,
                                    }}
                                >
                                    <img
                                        src={endpointsUrl + selectedImage}
                                        alt="Selected Slide"
                                        style={{
                                            // boxShadow: "6px 5px 20px 0px rgba(0,0,0,0.7)",
                                            borderRadius: "10px",
                                            width: isMobile ? "30%" : "90%",
                                            // maxWidth: "400px",
                                            height: "500px",
                                            // objectFit: "contain"
                                        }}
                                    />
                                </Box>

                                <Box
                                    sx={{
                                        border: "2px solid darkgrey",
                                        borderRadius: "70px",
                                        padding: "12px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: "#fff",
                                        width: isMobile ? "95%" : "90%",
                                        mx: "auto",
                                        mt: 2,
                                    }}
                                >
                                    <IconButton ref={prevRef} sx={{ mr: 1, bgcolor: "#FFC043", boxShadow: "0 2px 4px rgba(0,0,0,0.3)" }}>
                                        <ArrowBackIos />
                                    </IconButton>

                                    <Box sx={{ width: isMobile ? "80%" : "85%" }}>
                                        <Swiper
                                            onSwiper={setThumbsSwiper}
                                            spaceBetween={isMobile ? 1 : 5}
                                            slidesPerView={isMobile ? 7 : 2}
                                            watchSlidesProgress
                                            modules={[Navigation, Thumbs]}
                                            navigation={{
                                                prevEl: prevRef.current,
                                                nextEl: nextRef.current
                                            }}
                                        >
                                            {instituteRes?.gallery.map((item, i) => (
                                                <SwiperSlide key={`thumb-${i}`}>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                border: selectedImage === item ? "2px solid #0056ff" : "2px solid #ccc",
                                                                borderRadius: "50%",
                                                                padding: "2px",
                                                                transition: "border 0.3s ease",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => setSelectedImage(item)}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    borderRadius: "50%",
                                                                    overflow: "hidden",
                                                                    width: "100px",
                                                                    height: "100px",
                                                                }}
                                                            >
                                                                <img
                                                                    src={endpointsUrl + item}
                                                                    alt={`Thumbnail ${i}`}
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        objectFit: "cover",
                                                                        borderRadius: "50%",
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </Box>

                                    <IconButton ref={nextRef} sx={{ ml: 1, bgcolor: "#FFC043", boxShadow: "0 2px 4px rgba(0,0,0,0.3)" }}>
                                        <ArrowForwardIos />
                                    </IconButton>
                                </Box>

                            </Grid>
                        </Grid>
                    )}

                </Grid>
            </Grid>
        </div>
    );
};
